// Generated from ai_engine/analytics/events.yaml by scripts/generate_event_registry.py.
// Do not edit this artifact by hand.
export const EVENT_REGISTRY_SOURCE_SHA256 =
    "7dedce740341cfcbb20a055504374ec302ef56d9c069b72211fdfa34237c844e" as const;
export const EVENT_REGISTRY_CONTENT_SHA256 =
    "ec3792a9915fea6c87d23ae7b91a9d5e453721e070146565fcb1544562c8df40" as const;
export const EVENT_REGISTRY_VERSION = 22 as const;
export const EVENT_VERSION = 1 as const;

export type EventOwner = "client" | "server";
export type EventSink = "amplitude" | "product_event";
export type EventPlatform = "embed" | "native" | "tablet" | "web";
export type EventPropertyType = "boolean" | "integer" | "number" | "string";

export interface EventPropertyDefinition {
    type: EventPropertyType;
    required: boolean;
}

export interface EventDefinition {
    name: string;
    version: typeof EVENT_VERSION;
    owner: EventOwner;
    sinks: readonly EventSink[];
    /** Omitted = accepted from every shell; else only these. */
    platforms?: readonly EventPlatform[];
    /** Why this registered event intentionally has no client call site. */
    notEmittedReason?: string;
    properties: Readonly<Record<string, EventPropertyDefinition>>;
}

export const EVENT_REGISTRY = [
    {
        name: "send_message",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            conversation_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            message_type: { type: "string", required: false },
        },
    },
    {
        name: "create_conversation",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            message_type: { type: "string", required: false },
        },
    },
    {
        name: "view_reference",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            reference_type: { type: "string", required: false },
        },
    },
    {
        name: "view_node",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            node_id: { type: "string", required: false },
        },
    },
    {
        name: "connection_hover",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            connection_id: { type: "string", required: false },
            destination_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            viewer_context: { type: "string", required: false },
            tag_type: { type: "string", required: false },
        },
    },
    {
        name: "connection_hover_2s",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            connection_id: { type: "string", required: false },
            destination_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            viewer_context: { type: "string", required: false },
            tag_type: { type: "string", required: false },
        },
    },
    {
        name: "connection_hover_deliberate",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            connection_id: { type: "string", required: false },
            destination_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            viewer_context: { type: "string", required: false },
            tag_type: { type: "string", required: false },
            shown_ms: { type: "integer", required: true },
        },
    },
    {
        name: "connection_click",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            connection_id: { type: "string", required: false },
            destination_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            viewer_context: { type: "string", required: false },
            tag_type: { type: "string", required: false },
            direction: { type: "string", required: false },
            origin: { type: "string", required: false },
            connection_count: { type: "integer", required: false },
        },
    },
    {
        name: "download_table",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            message_id: { type: "string", required: false },
            output_type: { type: "string", required: false },
        },
    },
    {
        name: "copy_table",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            message_id: { type: "string", required: false },
            output_type: { type: "string", required: false },
        },
    },
    {
        name: "download_spreadsheet",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            message_id: { type: "string", required: false },
            output_type: { type: "string", required: false },
        },
    },
    {
        name: "copy_spreadsheet",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            message_id: { type: "string", required: false },
            output_type: { type: "string", required: false },
        },
    },
    {
        name: "submittal_view_file",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            submittal_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
        },
    },
    {
        name: "auth_continue_with_email",
        version: 1,
        owner: "client",
        sinks: ["amplitude"],
        properties: {},
    },
    {
        name: "auth_continue_with_google",
        version: 1,
        owner: "client",
        sinks: ["amplitude"],
        properties: {},
    },
    {
        name: "auth_continue_with_ms",
        version: 1,
        owner: "client",
        sinks: ["amplitude"],
        properties: {},
    },
    {
        name: "viewer_open",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            sheet: { type: "string", required: false },
            viewer_context: { type: "string", required: true },
            source: { type: "string", required: false },
        },
    },
    {
        name: "sheet_view",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        notEmittedReason: "Kept for legacy ingest only, superseded by viewer_open, and emitted by no client (locked by eventRegistry.test.ts). The viewer direct/reference split therefore rests entirely on viewer_open.",
        properties: {
            doc_id: { type: "string", required: false },
            sheet: { type: "string", required: false },
            source: { type: "string", required: false },
        },
    },
    {
        name: "viewer_mode_change",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            mode: { type: "string", required: false },
        },
    },
    {
        name: "viewer_download",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            output_type: { type: "string", required: false },
        },
    },
    {
        name: "sheet_version_switch",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            revision_id: { type: "string", required: false },
        },
    },
    {
        name: "overlay_view",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            revision_id: { type: "string", required: false },
        },
    },
    {
        name: "search_run",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            scope: { type: "string", required: false },
            n_filters: { type: "integer", required: false },
        },
    },
    {
        name: "search_result_click",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            scope: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            result_type: { type: "string", required: false },
        },
    },
    {
        name: "search_export_csv",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            scope: { type: "string", required: false },
            n_results: { type: "integer", required: false },
        },
    },
    {
        name: "markup_publish",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            markup_set_id: { type: "string", required: false },
            n_shapes: { type: "integer", required: false },
        },
    },
    {
        name: "markup_download",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            markup_set_id: { type: "string", required: false },
            output_type: { type: "string", required: false },
        },
    },
    {
        name: "markup_calibrate",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            markup_set_id: { type: "string", required: false },
        },
    },
    {
        name: "connection_save",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            connection_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            n_pages: { type: "integer", required: false },
        },
    },
    {
        name: "connection_destination_set",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            connection_id: { type: "string", required: false },
            destination_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
        },
    },
    {
        name: "connection_break",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            connection_id: { type: "string", required: false },
            destination_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
        },
    },
    {
        name: "document_upload",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            category: { type: "string", required: false },
            n_files: { type: "integer", required: false },
            mb: { type: "number", required: false },
        },
    },
    {
        name: "revision_upload",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            revision_id: { type: "string", required: false },
            n_files: { type: "integer", required: false },
            mb: { type: "number", required: false },
        },
    },
    {
        name: "spec_upload",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            n_files: { type: "integer", required: false },
            mb: { type: "number", required: false },
        },
    },
    {
        name: "schedule_upload",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            n_files: { type: "integer", required: false },
            mb: { type: "number", required: false },
        },
    },
    {
        name: "document_category_view",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            category: { type: "string", required: false },
        },
    },
    {
        name: "areas_manage",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            action: { type: "string", required: false },
            area_id: { type: "string", required: false },
        },
    },
    {
        name: "conversation_open",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            source: { type: "string", required: false },
        },
    },
    {
        name: "reference_export_csv",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            conversation_id: { type: "string", required: false },
            n_results: { type: "integer", required: false },
        },
    },
    {
        name: "submittal_upload",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doc_id: { type: "string", required: false },
            n_files: { type: "integer", required: false },
            mb: { type: "number", required: false },
        },
    },
    {
        name: "submittal_review_open",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            submittal_id: { type: "string", required: false },
            review_id: { type: "string", required: false },
        },
    },
    {
        name: "submittal_export",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            review_id: { type: "string", required: false },
            output_type: { type: "string", required: false },
        },
    },
    {
        name: "submittal_register_view",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            source: { type: "string", required: false },
        },
    },
    {
        name: "rfi_ask",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            rfi_id: { type: "string", required: false },
            source: { type: "string", required: false },
        },
    },
    {
        name: "rfi_link_approve",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            rfi_id: { type: "string", required: false },
            link_id: { type: "string", required: false },
        },
    },
    {
        name: "rfi_link_reject",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            rfi_id: { type: "string", required: false },
            link_id: { type: "string", required: false },
        },
    },
    {
        name: "rfi_link_add",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            rfi_id: { type: "string", required: false },
            link_id: { type: "string", required: false },
        },
    },
    {
        name: "rn_dashboard_view",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            revision_id: { type: "string", required: false },
        },
    },
    {
        name: "rn_review_open",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            revision_id: { type: "string", required: false },
            review_id: { type: "string", required: false },
        },
    },
    {
        name: "cr_dashboard_view",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            run_id: { type: "string", required: false },
        },
    },
    {
        name: "cr_issue_action",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            run_id: { type: "string", required: false },
            issue_id: { type: "string", required: false },
            action: { type: "string", required: false },
        },
    },
    {
        name: "ct_view",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            view: { type: "string", required: false },
        },
    },
    {
        name: "ct_export",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            output_type: { type: "string", required: false },
        },
    },
    {
        name: "ct_sync",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            provider: { type: "string", required: false },
            action: { type: "string", required: false },
        },
    },
    {
        name: "integration_link",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            provider: { type: "string", required: false },
        },
    },
    {
        name: "integration_unlink",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            provider: { type: "string", required: false },
        },
    },
    {
        name: "embed_open",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            provider: { type: "string", required: false },
            doc_id: { type: "string", required: false },
        },
    },
    {
        name: "active_time_slice",
        version: 1,
        owner: "client",
        sinks: ["product_event"],
        properties: {
            usage_session_id: { type: "string", required: true },
            feature: { type: "string", required: true },
            active_seconds: { type: "integer", required: true },
            viewer_context: { type: "string", required: false },
        },
    },
    {
        name: "auth_session_started",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            member_session_id: { type: "string", required: true },
        },
    },
    {
        name: "session_start",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            bucket_minutes: { type: "integer", required: false },
        },
    },
    {
        name: "revision_publish",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            doc_id: { type: "string", required: false },
            revision_id: { type: "string", required: false },
        },
    },
    {
        name: "submittal_review_complete",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            submittal_id: { type: "string", required: false },
            review_id: { type: "string", required: false },
            status: { type: "string", required: false },
        },
    },
    {
        name: "rfi_review_complete",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            rfi_id: { type: "string", required: false },
            review_id: { type: "string", required: false },
            status: { type: "string", required: false },
        },
    },
    {
        name: "tool_run_complete",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            run_id: { type: "string", required: false },
            tool_type: { type: "string", required: false },
            status: { type: "string", required: false },
        },
    },
    {
        name: "miranda_turn_complete",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            conversation_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            status: { type: "string", required: false },
            failure: { type: "string", required: false },
            session: { type: "string", required: false },
            duration_seconds: { type: "integer", required: false },
            release: { type: "string", required: false },
        },
    },
    {
        name: "miranda_run_complete",
        version: 1,
        owner: "server",
        sinks: ["product_event"],
        properties: {
            run_id: { type: "string", required: false },
            doc_id: { type: "string", required: false },
            conversation_id: { type: "string", required: false },
            status: { type: "string", required: false },
            applied_changes: { type: "integer", required: false },
            duration_seconds: { type: "integer", required: false },
            release: { type: "string", required: false },
            executor_cost_cents: { type: "integer", required: false },
            assistant_cost_cents: { type: "integer", required: false },
            total_cost_cents: { type: "integer", required: false },
            executor_turns: { type: "integer", required: false },
            assistant_turns: { type: "integer", required: false },
            assistant_contexts: { type: "integer", required: false },
            executor_model: { type: "string", required: false },
            assistant_model: { type: "string", required: false },
            tool_calls: { type: "integer", required: false },
            tool_errors: { type: "integer", required: false },
            belt_calls: { type: "integer", required: false },
            belt_failures: { type: "integer", required: false },
            images: { type: "integer", required: false },
            image_limit_cancels: { type: "integer", required: false },
            continuations: { type: "integer", required: false },
            rounds: { type: "integer", required: false },
            applied_as_proposed_pct: { type: "integer", required: false },
            last_residue_writes: { type: "integer", required: false },
            active_seconds: { type: "integer", required: false },
        },
    },
    {
        name: "tab_selected",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["native"],
        properties: {
            tab: { type: "string", required: false },
        },
    },
    {
        name: "sheet_search",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["native"],
        properties: {
            query_length: { type: "integer", required: false },
        },
    },
    {
        name: "marvin_answer_notified",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["native"],
        properties: {
            status: { type: "string", required: false },
        },
    },
    {
        name: "marvin_notification_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["native"],
        properties: {},
    },
    {
        name: "offline_download_started",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["native"],
        properties: {
            doc_id: { type: "string", required: false },
            scope: { type: "string", required: false },
            policy_managed: { type: "boolean", required: false },
            run_id: { type: "string", required: false },
            trigger: { type: "string", required: false },
        },
    },
    {
        name: "offline_download_completed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["native"],
        properties: {
            doc_id: { type: "string", required: false },
            scope: { type: "string", required: false },
            run_id: { type: "string", required: false },
            trigger: { type: "string", required: false },
        },
    },
    {
        name: "offline_download_failed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["native"],
        properties: {
            doc_id: { type: "string", required: false },
            scope: { type: "string", required: false },
            reason: { type: "string", required: false },
            error: { type: "string", required: false },
            run_id: { type: "string", required: false },
            trigger: { type: "string", required: false },
            failed_sheet_count: { type: "integer", required: false },
        },
    },
    {
        name: "offline_download_interrupted",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["native"],
        properties: {
            doc_id: { type: "string", required: false },
            scope: { type: "string", required: false },
            reason: { type: "string", required: false },
            error: { type: "string", required: false },
            run_id: { type: "string", required: true },
            trigger: { type: "string", required: true },
        },
    },
    {
        name: "page_load",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            page: { type: "string", required: true },
            outcome: { type: "string", required: true },
            doc_id: { type: "string", required: false },
            sheet: { type: "string", required: false },
            load_ms: { type: "integer", required: false },
            server_ms: { type: "integer", required: false },
            api_ms: { type: "integer", required: false },
            blocking_ms: { type: "integer", required: false },
            request_count: { type: "integer", required: false },
            transfer_bytes: { type: "integer", required: false },
            asset_bytes: { type: "integer", required: false },
            asset_ms: { type: "integer", required: false },
            cache_state: { type: "string", required: false },
            effective_type: { type: "string", required: false },
            source: { type: "string", required: false },
            open_ms: { type: "integer", required: false },
            keystroke_p95_ms: { type: "integer", required: false },
            keystroke_count: { type: "integer", required: false },
            notes_ms: { type: "integer", required: false },
            index_age_ms: { type: "integer", required: false },
            enter_to_paint_ms: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_assembled",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            seed_id: { type: "string", required: false },
            seed_kind: { type: "string", required: false },
            n_tiles: { type: "integer", required: false },
            n_candidates: { type: "integer", required: false },
            truncated: { type: "boolean", required: false },
        },
    },
    {
        name: "workbench_tile_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            how: { type: "string", required: true },
            tile_kind: { type: "string", required: false },
            seed_id: { type: "string", required: false },
            sheet: { type: "string", required: false },
            view: { type: "string", required: false },
        },
    },
    {
        name: "admission_notice",
        version: 1,
        owner: "client",
        sinks: ["product_event"],
        properties: {
            kind: { type: "string", required: true },
            status: { type: "integer", required: false },
            code: { type: "string", required: false },
            token_valid: { type: "boolean", required: true },
            refusal: { type: "string", required: false },
        },
    },
    {
        name: "workbench_view_changed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            view: { type: "string", required: true },
            seed_id: { type: "string", required: false },
            n_tiles: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_stage_unavailable",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            surface: { type: "string", required: true },
            reason: { type: "string", required: true },
            seed_id: { type: "string", required: false },
        },
    },
    {
        name: "workbench_stage_expanded",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            seed_id: { type: "string", required: false },
            tile_kind: { type: "string", required: false },
            n_added: { type: "integer", required: false },
            from_bench: { type: "boolean", required: false },
        },
    },
    {
        name: "workbench_home_shown",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            start: { type: "string", required: true },
            render: { type: "string", required: false },
            theme: { type: "string", required: false },
            n_nodes: { type: "integer", required: false },
            n_suggested: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_home_node_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            kind: { type: "string", required: true },
            sheet: { type: "string", required: false },
        },
    },
    {
        name: "workbench_asked",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            source: { type: "string", required: true },
            query_len: { type: "integer", required: false },
            conversation_id: { type: "string", required: false },
        },
    },
    {
        name: "workbench_activity_lit",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            n_lit: { type: "integer", required: true },
            n_unplaced: { type: "integer", required: true },
            n_tool_calls: { type: "integer", required: false },
            run_id: { type: "string", required: false },
            duration_ms: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_explore_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            source: { type: "string", required: true },
            sheet: { type: "string", required: false },
            section_id: { type: "string", required: false },
            n_incoming: { type: "integer", required: false },
            n_outgoing: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_answer_explored",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            message_id: { type: "string", required: false },
            n_cited: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_search_replayed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            source: { type: "string", required: true },
            n_lit: { type: "integer", required: false },
            n_unplaced: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_answer_skipped",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {},
    },
    {
        name: "workbench_explore_travelled",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            direction: { type: "string", required: true },
            depth: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_trail_back",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            replay: { type: "boolean", required: true },
            steps: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_explore_panel_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            sheet: { type: "string", required: false },
        },
    },
    {
        name: "workbench_column_expanded",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            direction: { type: "string", required: true },
            n_total: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_whole_graph_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            source: { type: "string", required: true },
        },
    },
    {
        name: "workbench_issue_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            surface: { type: "string", required: true },
        },
    },
    {
        name: "workbench_experience_switched",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            to: { type: "string", required: true },
            source: { type: "string", required: true },
        },
    },
    {
        name: "workbench_classic_prompt_dismissed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {},
    },
    {
        name: "workbench_whats_new_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            n_items: { type: "integer", required: false },
            n_unread: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_session_resumed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            outcome: { type: "string", required: true },
            dropped: { type: "integer", required: false },
            trail_len: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_dock_toggled",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            dock: { type: "string", required: true },
            open: { type: "boolean", required: false },
        },
    },
    {
        name: "workbench_theme_changed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            theme: { type: "string", required: true },
        },
    },
    {
        name: "workbench_booth_started",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            n_replays: { type: "integer", required: false },
            warm: { type: "string", required: false },
        },
    },
    {
        name: "workbench_booth_paused",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {},
    },
    {
        name: "workbench_booth_recording_played",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            via: { type: "string", required: true },
        },
    },
    {
        name: "workbench_booth_activated",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["web"],
        properties: {},
    },
    {
        name: "workbench_booth_exited",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        platforms: ["web"],
        properties: {
            via: { type: "string", required: true },
        },
    },
    {
        name: "viewer_back",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            sheet_id: { type: "string", required: false },
            kept_viewport: { type: "boolean", required: true },
        },
    },
    {
        name: "viewer_goto_sheet",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            sheet_id: { type: "string", required: false },
            via: { type: "string", required: true },
        },
    },
    {
        name: "coverage_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            sheet_id: { type: "string", required: false },
            hits: { type: "integer", required: true },
        },
    },
    {
        name: "coverage_hit_chosen",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            sheet_id: { type: "string", required: false },
            target_sheet_id: { type: "string", required: false },
            as: { type: "string", required: true },
        },
    },
    {
        name: "discipline_swapped",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            sheet_id: { type: "string", required: false },
            target_sheet_id: { type: "string", required: false },
            disc: { type: "string", required: true },
        },
    },
    {
        name: "rfi_view_on_drawing",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            rfi_id: { type: "string", required: false },
            pinned: { type: "boolean", required: true },
        },
    },
    {
        name: "palette_result_chosen",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            kind: { type: "string", required: true },
            landed: { type: "boolean", required: false },
        },
    },
    {
        name: "spec_card_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            via: { type: "string", required: true },
            code: { type: "string", required: false },
        },
    },
    {
        name: "workbench_place_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            via: { type: "string", required: true },
            level: { type: "integer", required: false },
            disc: { type: "string", required: false },
        },
    },
    {
        name: "workbench_here_card_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            doors: { type: "integer", required: true },
        },
    },
    {
        name: "workbench_trade_crossfaded",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            from: { type: "string", required: false },
            to: { type: "string", required: true },
        },
    },
    {
        name: "workbench_handoff",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            direction: { type: "string", required: true },
            zoom: { type: "number", required: false },
        },
    },
    {
        name: "workbench_step_scrubbed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            step: { type: "integer", required: true },
            steps: { type: "integer", required: false },
        },
    },
    {
        name: "workbench_link_followed",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            via: { type: "string", required: true },
        },
    },
    {
        name: "workbench_gathered",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            n_connected: { type: "integer", required: true },
            n_groups: { type: "integer", required: true },
        },
    },
    {
        name: "workbench_apron_grouped",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            by: { type: "string", required: true },
        },
    },
    {
        name: "workbench_spec_book_opened",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            n_sections: { type: "integer", required: true },
        },
    },
    {
        name: "workbench_room_entered",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            walls: { type: "integer", required: true },
            missing: { type: "integer", required: true },
        },
    },
    {
        name: "workbench_unconfirmed_toggled",
        version: 1,
        owner: "client",
        sinks: ["product_event", "amplitude"],
        properties: {
            shown: { type: "boolean", required: true },
        },
    },
] as const satisfies readonly EventDefinition[];

export const AnalyticsEvents = {
    SEND_MESSAGE: "send_message",
    CREATE_CONVERSATION: "create_conversation",
    CONVERSATION_VIEW_REFERENCE: "view_reference",
    VIEW_NODE: "view_node",
    CONNECTION_HOVER: "connection_hover",
    CONNECTION_HOVER_2S: "connection_hover_2s",
    CONNECTION_HOVER_DELIBERATE: "connection_hover_deliberate",
    CONNECTION_CLICK: "connection_click",
    DOWNLOAD_TABLE: "download_table",
    COPY_TABLE: "copy_table",
    DOWNLOAD_SPREADSHEET: "download_spreadsheet",
    COPY_SPREADSHEET: "copy_spreadsheet",
    SUBMITTAL_VIEW_FILE: "submittal_view_file",
    AUTH_CONTINUE_WITH_EMAIL: "auth_continue_with_email",
    AUTH_CONTINUE_WITH_GOOGLE: "auth_continue_with_google",
    AUTH_CONTINUE_WITH_MS: "auth_continue_with_ms",
    VIEWER_OPEN: "viewer_open",
    SHEET_VIEW: "sheet_view",
    VIEWER_MODE_CHANGE: "viewer_mode_change",
    VIEWER_DOWNLOAD: "viewer_download",
    SHEET_VERSION_SWITCH: "sheet_version_switch",
    OVERLAY_VIEW: "overlay_view",
    SEARCH_RUN: "search_run",
    SEARCH_RESULT_CLICK: "search_result_click",
    SEARCH_EXPORT_CSV: "search_export_csv",
    MARKUP_PUBLISH: "markup_publish",
    MARKUP_DOWNLOAD: "markup_download",
    MARKUP_CALIBRATE: "markup_calibrate",
    CONNECTION_SAVE: "connection_save",
    CONNECTION_DESTINATION_SET: "connection_destination_set",
    CONNECTION_BREAK: "connection_break",
    DOCUMENT_UPLOAD: "document_upload",
    REVISION_UPLOAD: "revision_upload",
    SPEC_UPLOAD: "spec_upload",
    SCHEDULE_UPLOAD: "schedule_upload",
    DOCUMENT_CATEGORY_VIEW: "document_category_view",
    AREAS_MANAGE: "areas_manage",
    CONVERSATION_OPEN: "conversation_open",
    REFERENCE_EXPORT_CSV: "reference_export_csv",
    SUBMITTAL_UPLOAD: "submittal_upload",
    SUBMITTAL_REVIEW_OPEN: "submittal_review_open",
    SUBMITTAL_EXPORT: "submittal_export",
    SUBMITTAL_REGISTER_VIEW: "submittal_register_view",
    RFI_ASK: "rfi_ask",
    RFI_LINK_APPROVE: "rfi_link_approve",
    RFI_LINK_REJECT: "rfi_link_reject",
    RFI_LINK_ADD: "rfi_link_add",
    RN_DASHBOARD_VIEW: "rn_dashboard_view",
    RN_REVIEW_OPEN: "rn_review_open",
    CR_DASHBOARD_VIEW: "cr_dashboard_view",
    CR_ISSUE_ACTION: "cr_issue_action",
    CT_VIEW: "ct_view",
    CT_EXPORT: "ct_export",
    CT_SYNC: "ct_sync",
    INTEGRATION_LINK: "integration_link",
    INTEGRATION_UNLINK: "integration_unlink",
    EMBED_OPEN: "embed_open",
    ACTIVE_TIME_SLICE: "active_time_slice",
    AUTH_SESSION_STARTED: "auth_session_started",
    SESSION_START: "session_start",
    REVISION_PUBLISH: "revision_publish",
    SUBMITTAL_REVIEW_COMPLETE: "submittal_review_complete",
    RFI_REVIEW_COMPLETE: "rfi_review_complete",
    TOOL_RUN_COMPLETE: "tool_run_complete",
    MIRANDA_TURN_COMPLETE: "miranda_turn_complete",
    MIRANDA_RUN_COMPLETE: "miranda_run_complete",
    TAB_SELECTED: "tab_selected",
    SHEET_SEARCH: "sheet_search",
    MARVIN_ANSWER_NOTIFIED: "marvin_answer_notified",
    MARVIN_NOTIFICATION_OPENED: "marvin_notification_opened",
    OFFLINE_DOWNLOAD_STARTED: "offline_download_started",
    OFFLINE_DOWNLOAD_COMPLETED: "offline_download_completed",
    OFFLINE_DOWNLOAD_FAILED: "offline_download_failed",
    OFFLINE_DOWNLOAD_INTERRUPTED: "offline_download_interrupted",
    PAGE_LOAD: "page_load",
    WORKBENCH_ASSEMBLED: "workbench_assembled",
    WORKBENCH_TILE_OPENED: "workbench_tile_opened",
    ADMISSION_NOTICE: "admission_notice",
    WORKBENCH_VIEW_CHANGED: "workbench_view_changed",
    WORKBENCH_STAGE_UNAVAILABLE: "workbench_stage_unavailable",
    WORKBENCH_STAGE_EXPANDED: "workbench_stage_expanded",
    WORKBENCH_HOME_SHOWN: "workbench_home_shown",
    WORKBENCH_HOME_NODE_OPENED: "workbench_home_node_opened",
    WORKBENCH_ASKED: "workbench_asked",
    WORKBENCH_ACTIVITY_LIT: "workbench_activity_lit",
    WORKBENCH_EXPLORE_OPENED: "workbench_explore_opened",
    WORKBENCH_ANSWER_EXPLORED: "workbench_answer_explored",
    WORKBENCH_SEARCH_REPLAYED: "workbench_search_replayed",
    WORKBENCH_ANSWER_SKIPPED: "workbench_answer_skipped",
    WORKBENCH_EXPLORE_TRAVELLED: "workbench_explore_travelled",
    WORKBENCH_TRAIL_BACK: "workbench_trail_back",
    WORKBENCH_EXPLORE_PANEL_OPENED: "workbench_explore_panel_opened",
    WORKBENCH_COLUMN_EXPANDED: "workbench_column_expanded",
    WORKBENCH_WHOLE_GRAPH_OPENED: "workbench_whole_graph_opened",
    WORKBENCH_ISSUE_OPENED: "workbench_issue_opened",
    WORKBENCH_EXPERIENCE_SWITCHED: "workbench_experience_switched",
    WORKBENCH_CLASSIC_PROMPT_DISMISSED: "workbench_classic_prompt_dismissed",
    WORKBENCH_WHATS_NEW_OPENED: "workbench_whats_new_opened",
    WORKBENCH_SESSION_RESUMED: "workbench_session_resumed",
    WORKBENCH_DOCK_TOGGLED: "workbench_dock_toggled",
    WORKBENCH_THEME_CHANGED: "workbench_theme_changed",
    WORKBENCH_BOOTH_STARTED: "workbench_booth_started",
    WORKBENCH_BOOTH_PAUSED: "workbench_booth_paused",
    WORKBENCH_BOOTH_RECORDING_PLAYED: "workbench_booth_recording_played",
    WORKBENCH_BOOTH_ACTIVATED: "workbench_booth_activated",
    WORKBENCH_BOOTH_EXITED: "workbench_booth_exited",
    VIEWER_BACK: "viewer_back",
    VIEWER_GOTO_SHEET: "viewer_goto_sheet",
    COVERAGE_OPENED: "coverage_opened",
    COVERAGE_HIT_CHOSEN: "coverage_hit_chosen",
    DISCIPLINE_SWAPPED: "discipline_swapped",
    RFI_VIEW_ON_DRAWING: "rfi_view_on_drawing",
    PALETTE_RESULT_CHOSEN: "palette_result_chosen",
    SPEC_CARD_OPENED: "spec_card_opened",
    WORKBENCH_PLACE_OPENED: "workbench_place_opened",
    WORKBENCH_HERE_CARD_OPENED: "workbench_here_card_opened",
    WORKBENCH_TRADE_CROSSFADED: "workbench_trade_crossfaded",
    WORKBENCH_HANDOFF: "workbench_handoff",
    WORKBENCH_STEP_SCRUBBED: "workbench_step_scrubbed",
    WORKBENCH_LINK_FOLLOWED: "workbench_link_followed",
    WORKBENCH_GATHERED: "workbench_gathered",
    WORKBENCH_APRON_GROUPED: "workbench_apron_grouped",
    WORKBENCH_SPEC_BOOK_OPENED: "workbench_spec_book_opened",
    WORKBENCH_ROOM_ENTERED: "workbench_room_entered",
    WORKBENCH_UNCONFIRMED_TOGGLED: "workbench_unconfirmed_toggled",
} as const;

type EventDefinitionUnion = (typeof EVENT_REGISTRY)[number];
export type AnalyticsEventName = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
export type ClientAnalyticsEventName = Extract<EventDefinitionUnion, { owner: "client" }>["name"];

type EventPropertySchema<Name extends ClientAnalyticsEventName> = Extract<
    EventDefinitionUnion,
    { name: Name }
>["properties"];
type RequiredPropertyName<Name extends ClientAnalyticsEventName> = {
    [Key in keyof EventPropertySchema<Name>]: EventPropertySchema<Name>[Key] extends {
        required: true;
    }
        ? Key
        : never;
}[keyof EventPropertySchema<Name>];
type EventPropertyValue<Definition> = Definition extends { type: "boolean" }
    ? boolean
    : Definition extends { type: "integer" | "number" }
      ? number
      : string;
type TypedEventProperties<Name extends ClientAnalyticsEventName> = {
    [Key in RequiredPropertyName<Name>]: EventPropertyValue<EventPropertySchema<Name>[Key]>;
} & {
    [
        Key in Exclude<keyof EventPropertySchema<Name>, RequiredPropertyName<Name>>
    ]?: EventPropertyValue<EventPropertySchema<Name>[Key]> | null;
};
export type AnalyticsEventProperties<Name extends ClientAnalyticsEventName> = [
    keyof EventPropertySchema<Name>,
] extends [never]
    ? never
    : TypedEventProperties<Name>;
export type AnalyticsEventParameters<Name extends ClientAnalyticsEventName> = [
    RequiredPropertyName<Name>,
] extends [never]
    ? [params?: AnalyticsEventProperties<Name>]
    : [params: AnalyticsEventProperties<Name>];

export const EVENT_DEFINITIONS: ReadonlyMap<AnalyticsEventName, EventDefinition> = new Map(
    EVENT_REGISTRY.map((definition) => [definition.name, definition]),
);

export function isAnalyticsEventName(value: string): value is AnalyticsEventName {
    return EVENT_DEFINITIONS.has(value as AnalyticsEventName);
}
